module.exports = __webpack_public_path__ + "56671f8971add56ccf821536ec988827.pdf";